<ion-header class="background-lightmimbo">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onClose()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon
      ></ion-button>
    </ion-buttons>
    <ion-title>Phone Codes</ion-title>
  </ion-toolbar>
  <ion-searchbar
    (ionInput)="onFilterChanged(searchBar)"
    #searchBar
  ></ion-searchbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-list>
    <ion-item
      *ngFor="let country of filteredCodes"
      (click)="onSelect(country)"
      color="lightmimbo"
    >
      <ion-avatar slot="start">
        <ion-img [src]="country.flag"></ion-img
      ></ion-avatar>
      <ion-text> {{ country.name }}</ion-text>
      <ion-text class="code"> {{ country.number }}</ion-text>
    </ion-item>
  </ion-list>
</ion-content>
